<div class="master_image" *ngIf="masterImage">
	<img [src]="appService.getBaseServerAddress() + '/document_files/download/' + masterImage" />
	<!-- gallery btn -->
	<div class="container" style="position: relative; height: 100%;">
		<button class="white_btn" (click)="open()">{{'Vedi tutte le foto' | translate}}</button>
	</div>
</div>